import { useState } from "react";
import EducentreCard from "../../component/EducentreCard/EducentreCard";
import Typography from "antd/es/typography/Typography";
import Select from "antd/es/select";
import Row from "antd/es/grid/row";
import Divider from "antd/es/divider";
import Spin from "antd/es/spin";
import Empty from "antd/es/empty";
import { Drawer, Radio, Button, Space } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import "./Educentre.less";
import { useGetCourseRecommendationQuery } from "../../redux/services/educentre";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { EmptyCard } from "../../component";
import { useDispatch } from "react-redux";
import {
  setCurrentCoachingLogo,
  setCurrentCoachingName,
} from "../../redux/features/authSlice";

const Title = Typography;
const { Option } = Select;

const Educentre = () => {
  const { student_id } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // State for filters
  const [selectedSort, setSelectedSort] = useState(null);
  const [selectedRating, setSelectedRating] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);

  // State for sort drawer
  const [sortDrawerOpen, setSortDrawerOpen] = useState(false);
  const [sortOption, setSortOption] = useState("relevance");

  const { data: courseRecommendation, isLoading: courseRecommendationLoading } =
    useGetCourseRecommendationQuery({
      student_id: student_id,
      sort: selectedSort,
      rating: selectedRating,
      subject: selectedSubject,
      course: selectedCourse,
    });
  const handleCardClick = (coaching_id, coaching_name, coaching_logo) => {
    dispatch(setCurrentCoachingName(coaching_name));
    dispatch(setCurrentCoachingLogo(coaching_logo));
    navigate(`/educentre/${coaching_id}`);
  };

  const showSortDrawer = () => {
    setSortDrawerOpen(true);
  };

  const closeSortDrawer = () => {
    setSortDrawerOpen(false);
  };

  const handleSortChange = (e) => {
    const value = e.target.value;
    setSortOption(value);

    // Map the radio option to the actual sort value for the API
    let sortValue = null;
    switch (value) {
      case "rating_high_to_low":
        sortValue = "rating_desc";
        break;
      case "distance_low_to_high":
        sortValue = "distance_asc";
        break;
      case "cost_low_to_high":
        sortValue = "cost_asc";
        break;
      case "cost_high_to_low":
        sortValue = "cost_desc";
        break;
      default:
        sortValue = "relevance";
    }

    setSelectedSort(sortValue);
  };

  const getSortButtonText = () => {
    switch (sortOption) {
      case "rating_high_to_low":
        return "Rating: High to Low";
      case "distance_low_to_high":
        return "Distance: Low to High";
      case "cost_low_to_high":
        return "Cost: Low to High";
      case "cost_high_to_low":
        return "Cost: High to Low";
      default:
        return "Sort by";
    }
  };

  return (
    <div className='educentre-container'>
      <div className='filter-section'>
        <Button
          icon={<FilterOutlined />}
          onClick={showSortDrawer}
          style={{ marginRight: "4px" }}
        >
          {getSortButtonText()}
        </Button>

        <Select
          placeholder='Rating'
          style={{ marginRight: "4px" }}
          onChange={(value) => setSelectedRating(value)}
          options={[
            { value: 4, label: "4+" },
            { value: 3, label: "3+" },
            { value: 2, label: "2+" },
            { value: 1, label: "1+" },
          ]}
        />
        <Select
          placeholder='Subject'
          style={{ marginRight: "4px" }}
          onChange={(value) => setSelectedSubject(value)}
          options={[
            { value: "English", label: "English" },
            { value: "Hindi", label: "Hindi" },
            { value: "Maths", label: "Maths" },
          ]}
        />
        <Select
          placeholder='Course'
          style={{ marginRight: "4px" }}
          onChange={(value) => setSelectedCourse(value)}
          options={[
            { value: "Physics", label: "Physics" },
            { value: "Chemistry", label: "Chemistry" },
            { value: "Mathematics", label: "Mathematics" },
          ]}
        />
      </div>

      {/* Sort Drawer */}
      <Drawer
        title='Sort By'
        placement='bottom'
        closable={false}
        open={sortDrawerOpen}
        height={390}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
            <Button
              onClick={() => {
                setSortOption("relevance");
                setSelectedSort("relevance");
              }}
            >
              Clear
            </Button>
            <Button onClick={closeSortDrawer} type='primary' width='100%'>
              Apply
            </Button>
          </div>
        }
      >
        <Radio.Group
          onChange={handleSortChange}
          value={sortOption}
          style={{ width: "100%" }}
        >
          <Space direction='vertical' style={{ width: "100%" }}>
            <Radio
              value='relevance'
              style={{
                fontSize: "20px",
                width: "100%",
                height: "40px",
                alignItems: "center",
              }}
            >
              Relevance
            </Radio>
            <Radio
              value='rating_high_to_low'
              style={{
                fontSize: "20px",
                width: "100%",
                height: "40px",
                alignItems: "center",
              }}
            >
              Rating: High to Low
            </Radio>
            <Radio
              value='distance_low_to_high'
              style={{
                fontSize: "20px",
                width: "100%",
                height: "40px",
                alignItems: "center",
              }}
            >
              Distance: Low to High
            </Radio>
            <Radio
              value='cost_low_to_high'
              style={{
                fontSize: "20px",
                width: "100%",
                height: "40px",
                alignItems: "center",
              }}
            >
              Cost: Low to High
            </Radio>
            <Radio
              value='cost_high_to_low'
              style={{
                fontSize: "20px",
                width: "100%",
                height: "40px",
                alignItems: "center",
              }}
            >
              Cost: High to Low
            </Radio>
          </Space>
        </Radio.Group>
      </Drawer>

      <Divider className='divider'>EXPLORE</Divider>
      <Spin
        spinning={courseRecommendationLoading}
        style={{
          width: "100%",
          height: "350px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Row gutter={[16, 16]} className='educentre-content-container'>
          {courseRecommendation?.data?.length > 0 ? (
            courseRecommendation?.data?.map((course) => (
              <EducentreCard
                key={course.course_id}
                coachingName={course.coachingName}
                rating={course.rating}
                subject={course.course_subject}
                batchSize={course.batch_size}
                vacancy={course.vacancy}
                course_banner={course.course_banner}
                batch_start_date={course.batch_start_date}
                batch_end_date={course.batch_end_date}
                onClick={() =>
                  handleCardClick(
                    course.course_id,
                    course.coaching_name,
                    course.coaching_logo
                  )
                }
              />
            ))
          ) : (
            <Empty
              style={{ width: "100%", height: "100%" }}
              image='https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg'
              styles={{ image: { height: 40 } }}
            />
          )}
        </Row>
      </Spin>
    </div>
  );
};

export default Educentre;
